import ConsumerRoutePath from 'app/consumer-app/ConsumerRoutePath';
import IconLib from 'app/shared/components/icon/icon-lib';
import { useSetPageTitle } from 'app/shared/context-hooks/use-titlebar.hook';
import Button from 'app/shared/components/button/Button';
import Icon from 'app/shared/components/icon/Icon';
import { PropsOf } from 'app/tools/general.types';
import { Merge } from 'type-fest';
import React from 'react';

const SectionBox: React.FC = ({ children }) => (
  <>
    <div className="flex flex-col rounded border border-solid border-neutral-200">
      {children}
    </div>
  </>
);

const SectionButton: React.VFC<
  Merge<PropsOf<typeof Button>, { title: string; icon: IconLib }>
> = ({ title, icon, ...buttonProps }) => (
  <Button variant="text" className="flex-grow h-btn" {...buttonProps}>
    <Icon {...{ icon }} />
    <div className="flex-grow ml-1">
      <h4 className="m-0 mb-0.2 text-sm font-semibold text-left line-clamp-1">
        {title}
      </h4>
    </div>
    <Icon icon={IconLib.CHEVRON_RIGHT} />
  </Button>
);

export default function AddCard(): JSX.Element {
  useSetPageTitle('Add Payment Method');

  return (
    <>
      <SectionBox>
        <SectionButton
          title="Card"
          to={ConsumerRoutePath.USER_CARD_DETAILS}
          icon={IconLib.WALLET}
        />
      </SectionBox>
    </>
  );
}
